import { getOrThrow } from '@tectonics/utils/getters';
import type { Maybe } from '@tectonics/utils/types';
import { CheckoutReceiptGetter, type InstalmentsStrategy } from '../types';

export const getInstalmentsStrategy: CheckoutReceiptGetter<Maybe<InstalmentsStrategy>> = ({ instalments_strategy }) => instalments_strategy;

export const getSafeInstalmentsStrategy: CheckoutReceiptGetter<InstalmentsStrategy> = (receipts) =>
  getOrThrow(
    getInstalmentsStrategy(receipts) || undefined,
    'getSafeInstalmentsStrategy: there is no "instalments_strategy" in the receipts'
  );
